import R from 'app/assets/R'
import { BaseRow } from 'app/components/common/BaseRow'
import HeaderPage from 'app/components/header/components/HeaderPage'
import { FilterManagement } from 'app/components/tables/BaseTableManagement/FilterManagementTable'
import * as S from 'app/components/tables/BaseTableManagement/styles'
import { CreateJobTitle } from './components/CreateJobTitle'
import { useHookTable } from './hook'
import { BaseTableManagementWrapper } from './styles'
const JobTitleManagementContainer = () => {
  const {
    tableData,
    columns,
    handleTableChange,
    fetchNewData,
    filter,
    handleChangeFilter,
  } = useHookTable()
  return (
    <S.BaseManagementWrapper>
      <HeaderPage
        titleI18nKey={R.strings.job_title_content_management}
        isExport
        rightComponent={<CreateJobTitle fetchTable={fetchNewData} />}
      />
      <S.RootWrapper>
        <BaseRow>
          <FilterManagement
            handleChangeFilter={handleChangeFilter}
            filterData={filter}
          />
        </BaseRow>
        <BaseTableManagementWrapper
          columns={columns}
          dataSource={tableData.data}
          pagination={tableData.pagination}
          loading={tableData.loading}
          onChange={handleTableChange}
        />
      </S.RootWrapper>
    </S.BaseManagementWrapper>
  )
}
export default JobTitleManagementContainer
